$(document).ready(() => {

  if($('.id-29').length){
    $('div[itemprop="about"]').append('<div class="faqSection"></div>')
  }
  if($('.type-detail').length){
    $('.type-detail #tab-content').append(`
      <div class="faqSectin">
        <div class="left"><h3>Nejčastěji se ptáte</h3>
          <div class="faqSection"></div>
        </div>
        <div class="right">
          <img src="/user/documents/upload/bannery/faq-tinified.jpg" alt="Faq sekce">
        </div>
      </div>  
    `)
  }

  const origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
  const faqPath = '/nejcasteji-se-ptate/';
  const faqUrl = new URL(faqPath, origin).toString();
  const cacheKey = 'faqSection:' + faqUrl;
  const cached = sessionStorage.getItem(cacheKey);
  function parseNewsItems($wrapper) {
    const data = [];
    $wrapper.find('.news-item').each((_, el) => {
      const $t = $(el);
      const $title = $t.find('.title');
      const $img = $t.find('.image img');

      data.push({
        title: $title.text().trim(),
        url: $title.attr('href'),
        description: $t.find('.description').text().trim(),
        image: $img.attr('data-src') || $img.attr('src') || null
      });
    });
    return data;
  }

  if (cached) {
    const parsed = JSON.parse(cached);
    console.log('DATA z cache:', parsed);
    renderFaq(parsed, '.faqSection');
    // tady si můžeš vykreslit strukturu podle sebe
  } else {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: faqUrl,
      success: e => {
        const a = shoptet.common.createDocumentFromString(e);
        const $wrapper = $(a).find('.news-wrapper');
        if ($wrapper.length) {
          const parsed = parseNewsItems($wrapper);
          console.log('DATA z ajaxu:', parsed);
          renderFaq(parsed, '.faqSection');
          sessionStorage.setItem(cacheKey, JSON.stringify(parsed));
        } else {
          console.warn('Prvek .news-wrapper není v odpovědi nalezen.');
        }
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.error('Chyba při načítání faqu:', textStatus, errorThrown);
      }
    });
  }
});


function renderFaq(parsed, targetSelector) {
  const $target = $(targetSelector);
  $target.empty();

  parsed.forEach(item => {
    const html = `
      <div class="faq-card">
        <h3>${item.title}</h3>
        <div class="description" style="display:none"><p>${item.description}</p></div>
      </div>
    `;
    $target.append(html);
  });
}

$('html').on('click', '.faq-card h3', function(){
  $(this).toggleClass('openIt')
  $(this).closest('.faq-card').find('.description').slideToggle()
})
